import * as util from 'notebook/tables/excess/Util';

export default function (dividend: number, divisor: number, context?: string): number {
  if (divisor === 0) {
    throw new util.DivZeroError(`Evaluation of ${context} caused a divide by zero error.`);
  }
  return dividend / divisor;
}
